var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeteoSoleil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.1 32",
    style: {
      enableBackground: "new 0 0 32.1 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M16,24.3c-4.6,0-8.3-3.7-8.3-8.3c0-4.6,3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3C24.3,20.6,20.6,24.3,16,24.3 L16,24.3z M16,10.2c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8C21.8,12.8,19.2,10.2,16,10.2L16,10.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M16.2,5.4c-0.7,0-1.2-0.6-1.2-1.2V1.4c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2v2.8 C17.4,4.8,16.8,5.4,16.2,5.4L16.2,5.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M10.2,6.9c-0.4,0-0.8-0.2-1.1-0.6L7.8,3.9C7.4,3.3,7.6,2.6,8.2,2.2c0.6-0.3,1.3-0.1,1.7,0.5L11.3,5 c0.3,0.6,0.1,1.3-0.5,1.7C10.6,6.8,10.4,6.9,10.2,6.9L10.2,6.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M5.8,11.2c-0.2,0-0.4-0.1-0.6-0.2L2.8,9.6C2.2,9.3,2,8.5,2.3,8C2.7,7.4,3.4,7.2,4,7.5l2.4,1.4 C7,9.2,7.2,10,6.9,10.6C6.6,11,6.2,11.2,5.8,11.2L5.8,11.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M4.1,17.1H1.4c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2h2.8c0.7,0,1.2,0.6,1.2,1.2 C5.3,16.5,4.8,17.1,4.1,17.1L4.1,17.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M3.2,24.4c-0.4,0-0.8-0.2-1.1-0.6c-0.3-0.6-0.1-1.3,0.5-1.7L5,20.8c0.6-0.3,1.3-0.1,1.7,0.5 c0.3,0.6,0.1,1.3-0.5,1.7l-2.4,1.4C3.7,24.4,3.4,24.4,3.2,24.4L3.2,24.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M8.5,29.8c-0.2,0-0.4-0.1-0.6-0.2c-0.6-0.3-0.8-1.1-0.5-1.7l1.4-2.4c0.3-0.6,1.1-0.8,1.7-0.5 c0.6,0.3,0.8,1.1,0.5,1.7l-1.4,2.4C9.4,29.6,8.9,29.8,8.5,29.8L8.5,29.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M15.8,31.9c-0.7,0-1.2-0.6-1.2-1.2v-2.8c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2v2.8 C17,31.3,16.5,31.9,15.8,31.9L15.8,31.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M23.2,30c-0.4,0-0.8-0.2-1.1-0.6L20.7,27c-0.3-0.6-0.1-1.3,0.4-1.7c0.6-0.3,1.3-0.1,1.7,0.4l1.4,2.4 c0.3,0.6,0.1,1.3-0.4,1.7C23.6,30,23.4,30,23.2,30L23.2,30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M28.6,24.7c-0.2,0-0.4-0.1-0.6-0.2l-2.4-1.4c-0.6-0.3-0.8-1.1-0.5-1.7s1.1-0.8,1.7-0.5l2.4,1.4 c0.6,0.3,0.8,1.1,0.5,1.7C29.4,24.5,29,24.7,28.6,24.7L28.6,24.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M30.6,17.4h-2.8c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2h2.8c0.7,0,1.2,0.6,1.2,1.2 C31.8,16.9,31.3,17.4,30.6,17.4L30.6,17.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M26.4,11.5c-0.4,0-0.8-0.2-1.1-0.6c-0.3-0.6-0.1-1.3,0.5-1.7l2.4-1.4c0.6-0.3,1.3-0.1,1.7,0.5 c0.3,0.6,0.1,1.3-0.5,1.7L27,11.3C26.8,11.4,26.6,11.5,26.4,11.5L26.4,11.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M22.1,7.1c-0.2,0-0.4-0.1-0.6-0.2c-0.6-0.3-0.8-1.1-0.5-1.7l1.4-2.4c0.3-0.6,1.1-0.8,1.7-0.5 c0.6,0.3,0.8,1.1,0.5,1.7l-1.4,2.4C22.9,6.9,22.5,7.1,22.1,7.1L22.1,7.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeteoSoleil);
export default __webpack_public_path__ + "static/media/Meteo_Soleil.03aae641.svg";
export { ForwardRef as ReactComponent };